

































import { Vue, Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars
import CdkFilterPassBadges from "../../CdkFilterPassBadge/CdkFilterPassBadges.vue"; // eslint-disable-line no-unused-vars
import { FilterPassBadge } from "@/utils/filterPassBadges";

@Component({
  components: {
    CdkFilterPassBadges
  }
})
export default class TextContent extends Vue {
  @Prop({
    type: String,
    required: false,
    default: ""
  })
  genre?: string;

  @Prop({
    type: String,
    required: true
  })
  title!: string;

  @Prop({
    type: String,
    required: false
  })
  description?: string;

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  isEmbargoed?: boolean;

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  isCompact?: boolean;

  @Prop({
    type: String,
    required: false,
    default: ""
  })
  embargoed?: string;

  @Prop({
    type: Array,
    required: false,
    default: () => []
  })
  filterPassBadges?: FilterPassBadge[];
}
